import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardNewComponent } from './dashboard-new/dashboard-new.component';
import { FooterComponent } from './footer/footer.component';
import { GmdContactComponent } from './gmd-contact/gmd-contact.component';
import { GmdDashboardSortingComponent } from './gmd-dashboard-sorting/gmd-dashboard-sorting.component';
import { GmdEditComponent } from './gmd-edit/gmd-edit.component';
import { GmdInformationComponent } from './gmd-information/gmd-information.component';
import { GmdLocationComponent } from './gmd-location/gmd-location.component';

import { GMDComponent } from './GMD.component';
import { ViewResultsComponent } from './view-results/view-results.component';


const routes: Routes = [
  // { path: 'dashboardSorting', loadChildren: () => import(`./../dashboard-sorting/dashboard-sorting.module`).then(m => m.DashboardSortingModule) },
  // { path: 'admin', loadChildren: () => import(`./../admin/admin.module`).then(m => m.AdminModule)},
  {
    path: 'dashboard-gmd',
    component: DashboardNewComponent
  },
  {
    path: 'dashboard-gmd-sorting',
    component: GmdDashboardSortingComponent
  },
  {
    path: 'view-results',
    component: ViewResultsComponent
  },
  {
    path: 'gmd-edit',
    component: GmdEditComponent
  },
  {
    path: 'gmd-contact',
    component: GmdContactComponent
  },
  {
    path: 'gmd-information',
    component: GmdInformationComponent
  },
  {
    path: 'gmd-location',
    component: GmdLocationComponent
  },
  {
      path: '',
      component: DashboardNewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GMDRoutingModule { }


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/